export enum ApiCallMethod {
  Get = 'GET',
  Post = 'POST',
  Put = 'PUT',
  Patch = 'PATCH',
  Delete = 'DELETE',
}

export enum ApiRouteVisibility {
  Public = 'public',
  Private = 'private',
}

export enum ApiRouteUnauthenticatedPolicy {
  Throw = 'throw',
  Skip = 'skip',
}

export type ApiPrimitive = string | number | boolean | null;

export type ApiParamsRecord = Record<string, ApiPrimitive | undefined>;

export type ApiQueryValue = ApiPrimitive | ApiPrimitive[];

export type ApiQueryRecord = Record<string, ApiQueryValue | undefined>;

export type ApiParamsInput = object;

export type ApiQueryInput = object;

export interface ApiRouteAuthConfig {
  visibility?: ApiRouteVisibility;
  unauthenticatedPolicy?: ApiRouteUnauthenticatedPolicy;
}

export interface ApiAuthResolverInput {
  currentAccessToken?: string;
}

export type ApiAuthResolver = (
  input: ApiAuthResolverInput,
) => Promise<string | undefined> | string | undefined;

export interface InTypeApi<
  P extends ApiParamsInput | undefined = undefined,
  Q extends ApiQueryInput | undefined = undefined,
  B = undefined,
> {
  params?: P;
  query?: Q;
  body?: B;
  signal?: AbortSignal;
  headers?: Record<string, string>;
}

export interface FunctionizeConfig<
  P extends ApiParamsInput | undefined,
  _Q extends ApiQueryInput | undefined,
  _B,
> {
  method: ApiCallMethod;
  routeTemplate: string;
  defaultParams?: P;
  auth?: ApiRouteAuthConfig;
}

export interface VersionDeviation {
  compatible: boolean;
  smallMismatch: boolean;
  breakingMismatch: boolean;
  backendVersion: string;
  frontEndVersion: string;
}

export interface ApiTransportRequest<
  B,
  Q extends ApiQueryInput | undefined,
> {
  method: ApiCallMethod;
  url: string;
  headers: Record<string, string>;
  query?: Q;
  body?: B;
  signal?: AbortSignal;
}

export interface ApiTransport {
  request<
    TOutput,
    B = undefined,
    Q extends ApiQueryInput | undefined = undefined,
  >(input: ApiTransportRequest<B, Q>): Promise<TOutput>;
}
